<template>
  <v-form
    v-model="$storeCommun.ValidAutresRevenusCandidat"
    ref="refAutresRevenusCandidat"
    lazy-validation
  >
    <v-dialog v-model="dialogImmo.informations.model" width="500">
      <v-card>
        <v-card-title>{{ $storeUm6p.Label.Informations }}</v-card-title>
        <v-card-text>
          <p v-html="$storeUm6p.Label.AutresRevenus.PopupNBBienImmo"></p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialogImmo.informations.model = false"
          >
            Fermer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-col cols="12">
      <label class="asterisk">
        {{ $storeUm6p.Label.AutresRevenus.CandidatProprietaire }}
      </label>
    </v-col>
    <v-col cols="6" md="4">
      <v-autocomplete
        dense
        v-model="$storeCommun.InfosCandidature.ProprietaireDeBiensImmobiliersSecondaire"
        :item-text="$storeUniversite.itemLang"
        item-value="id"
        :items="$storeCatalogue.OuiNon"
        label=""
        outlined
        :rules="$storeReglesBourse.obligatoire"
        :disabled="$storeCommun.ReadOnly"
        @change="
        DisplayPopup($storeCommun.InfosCandidature.ProprietaireDeBiensImmobiliersSecondaire);
        addBienImmo(false)"
      ></v-autocomplete>
    </v-col>
    <div
      v-show="
        $storeCommun.InfosCandidature.ProprietaireDeBiensImmobiliersSecondaire ==
        $storeCatalogue.DataId.Oui
      "
    >
      <v-btn
        dark
        v-show="!$storeCommun.ReadOnly"
        @click="addBienImmo(true)"
        color="secondary"
      >
        {{ $storeUm6p.Label.Ajouter }}
      </v-btn>
    </div>
    <v-simple-table
    v-show="$storeCommun.InfosCandidature.ProprietaireDeBiensImmobiliersSecondaire == $storeCatalogue.DataId.Oui">
      <thead>
        <tr>
          <th class="asterisk">
            {{ $storeUm6p.Label.AutresRevenus.NombreBiens }}
          </th>
          <th class="asterisk">
            {{ $storeUm6p.Label.AutresRevenus.NatureBien }}
          </th>
          <th class="asterisk">
            {{ $storeUm6p.Label.AutresRevenus.SuperficieBien }}
          </th>
          <th class="asterisk">
            {{ $storeUm6p.Label.AutresRevenus.AdresseBien }}
          </th>
          <th class="asterisk">
            {{ $storeUm6p.Label.AutresRevenus.NumeroTitreFoncier }}
          </th>
          <th class="asterisk">
            {{ $storeUm6p.Label.AutresRevenus.DateAcquisitionBien }}
          </th>
          <th class="asterisk">
            {{ $storeUm6p.Label.AutresRevenus.ValeurAcquisitionBien }}
          </th>
          <th class="asterisk">
            {{ $storeUm6p.Label.AutresRevenus.ValeurEstimativeBien }}
          </th>
          <th class="asterisk">
            {{ $storeUm6p.Label.AutresRevenus.SourceEstimationBien }}
          </th>
        </tr>
      </thead>
      <tbody
        v-for="(bien, index) in this.$storeCommun.ListeAutresRevenus"
        :key="index"
      >
        <tr cols="12" v-show="!bien.Supprimer">
          <td class="pt-6">
            <v-text-field
              v-model="bien.NombreBiens"
              :rules="
                estProprietairedeBiensImmo
                  ? $storeReglesBourse.EstNumeriqueObligatoire
                  : []
              "
              :readonly="$storeCommun.ReadOnly"
              outlined
              dense
            />
          </td>
          <td class="pt-6">
            <v-autocomplete
              :label="$storeUm6p.Label.NatureBien"
              v-model="bien.NatureBien"
              item-text="lang00"
              item-value="id"
              :items="$storeCatalogue.NatureBien"
              clearable
              outlined
              :rules="
                estProprietairedeBiensImmo ? $storeReglesBourse.obligatoire : []
              "
              :readonly="$storeCommun.ReadOnly"
              :ref="'natbien' + index"
              :itemprop="$storeUm6p.Label.AutresRevenus.NatureBien"
              dense
            ></v-autocomplete>
          </td>
          <td class="pt-6">
            <v-text-field
              v-model="bien.Superficie"
              :rules="
                estProprietairedeBiensImmo
                  ? $storeReglesBourse.EstNumeriqueObligatoire
                  : []
              "
              :ref="'superficie' + index"
              :itemprop="$storeUm6p.Label.AutresRevenus.SuperficieBien"
              outlined
              :readonly="$storeCommun.ReadOnly"
              dense
            />
          </td>
          <td class="pt-6">
            <v-text-field
              v-model="bien.Adresse"
              :rules="
                estProprietairedeBiensImmo ? $storeReglesBourse.obligatoire : []
              "
              :ref="'adr' + index"
              :itemprop="$storeUm6p.Label.AutresRevenus.AdresseBien"
              :readonly="$storeCommun.ReadOnly"
              outlined
              dense
            />
          </td>
          <td class="pt-6">
            <v-text-field
              v-model="bien.NumeroTitreFoncier"
              :rules="
                estProprietairedeBiensImmo
                  ? $storeReglesBourse.obligatoire
                  : []
              "
              :ref="'numTitreFoncier' + index"
              :itemprop="$storeUm6p.Label.AutresRevenus.NumeroTitreFoncier"
              :readonly="$storeCommun.ReadOnly"
              outlined
              dense
            />
          </td>
          <td
            class="pt-6"
            style="padding-top: 0px !important"
          >
            <input
              class="dateAcquisitionClass"
              type="date"
              v-model="bien.DateAcquisition"
              :readonly="$storeCommun.ReadOnly"
              required
            />
          </td>
          <td class="pt-6">
            <v-text-field
              v-model="bien.ValeurAcquisition"
              :rules="
                estProprietairedeBiensImmo
                  ? [
                      $storeReglesBourse.NumObli.EstNumeriqueObligatoire0(
                        bien.ValeurAcquisition
                      ),
                    ]
                  : []
              "
              :ref="'valeurAcquisition' + index"
              :itemprop="$storeUm6p.Label.AutresRevenus.ValeurAcquisitionBien"
              :readonly="$storeCommun.ReadOnly"
              outlined
              dense
            />
          </td>
          <td class="pt-6">
            <v-text-field
              v-model="bien.ValeurEstimative"
              :rules="
                estProprietairedeBiensImmo
                  ? [
                      $storeReglesBourse.NumObli.EstNumeriqueObligatoire0(
                        bien.ValeurEstimative
                      ),
                    ]
                  : []
              "
              :ref="'valeurEstimative' + index"
              :itemprop="$storeUm6p.Label.AutresRevenus.ValeurEstimativeBien"
              :readonly="$storeCommun.ReadOnly"
              outlined
              dense
            />
          </td>
          <td class="pt-6">
            <v-text-field
              v-model="bien.SourceEstimation"
              :rules="
                estProprietairedeBiensImmo
                  ? $storeReglesBourse.obligatoire
                  : []
              "
              :ref="'sourceEstimation' + index"
              :itemprop="$storeUm6p.Label.AutresRevenus.SourceEstimationBien"
              :readonly="$storeCommun.ReadOnly"
              outlined
              dense
            />
          </td>
          <td class="text-center">
            <v-icon
              v-show="!$storeCommun.ReadOnly && index > 0"
              small
              class="mr-2"
              @click="deleteBiens(index)"
            >
              {{ icons.mdiDelete }}
            </v-icon>
          </td>
        </tr>
      </tbody>
    </v-simple-table>
    <v-divider></v-divider>
    <v-row>
      <v-col cols="12">
        <v-row>
          <v-col cols="12">
            <v-alert
              border="left"
              colored-border
              color="secondary"
              elevation="1"
            >
              {{
                $storeUm6p.Label.AutresRevenus.AutresRevenusAnnuelsDirham +
                $storeUm6p.Label.AutresRevenus.AutresRevenusTitle +
                $storeCommun.AnneeRevenus
              }}
            </v-alert>
          </v-col>
        </v-row>
        <v-simple-table>
          <tbody>
            <tr>
              <td>
                <label class="asterisk">{{
                  $storeUm6p.Label.AutresRevenus.RevenusAgricolesAnnuels
                }}</label>
              </td>
              <td>
                <VuetifyMoney
                  hide-details
                  dense
                  v-model="$storeCommun.AutreRevenuDto.RevenuAgricole"
                  v-bind:label="label"
                  v-bind:readonly="$storeCommun.ReadOnly"
                  v-bind:disabled="disabled"
                  v-bind:outlined="outlined"
                  v-bind:clearable="clearable"
                  v-bind:options="optionsDH"
                  :rules="$storeReglesBourse.obligatoire"
                  ref="revenuagricole"
                  :itemprop="
                    $storeUm6p.Label.AutresRevenus.RevenusAgricolesAnnuels
                  "
                />
              </td>
              <td>
                <label class="asterisk">{{
                  $storeUm6p.Label.AutresRevenus.RevenusLocatifNef
                }}</label>
              </td>
              <td>
                <VuetifyMoney
                  hide-details
                  dense
                  v-model="$storeCommun.AutreRevenuDto.RevenuLocatifNet"
                  v-bind:label="label"
                  v-bind:readonly="$storeCommun.ReadOnly"
                  v-bind:disabled="disabled"
                  v-bind:outlined="outlined"
                  :rules="$storeReglesBourse.obligatoire"
                  ref="revenulocatif"
                  :itemprop="$storeUm6p.Label.AutresRevenus.RevenusLocatifNef"
                  v-bind:clearable="clearable"
                  v-bind:options="optionsDH"
                />
              </td>
            </tr>
            <tr>
              <td>
                <label class="asterisk">
                  {{ $storeUm6p.Label.AutresRevenus.Dividendes }}</label
                >
              </td>
              <td>
                <VuetifyMoney
                  hide-details
                  dense
                  v-model="$storeCommun.AutreRevenuDto.Dividendes"
                  v-bind:label="label"
                  v-bind:readonly="$storeCommun.ReadOnly"
                  v-bind:disabled="disabled"
                  v-bind:outlined="outlined"
                  :rules="$storeReglesBourse.obligatoire"
                  ref="dividendes"
                  :itemprop="$storeUm6p.Label.AutresRevenus.Dividendes"
                  v-bind:clearable="clearable"
                  v-bind:options="optionsDH"
                />
              </td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>
                <label class="asterisk">
                  {{ $storeUm6p.Label.AutresRevenus.AutreRevenusNetAnnuels }}
                </label>
              </td>
              <td>
                <VuetifyMoney
                  hide-details
                  dense
                  v-model="$storeCommun.AutreRevenuDto.AutresRevenus"
                  v-bind:label="label"
                  v-bind:readonly="$storeCommun.ReadOnly"
                  v-bind:disabled="disabled"
                  v-bind:outlined="outlined"
                  :rules="$storeReglesBourse.obligatoire"
                  ref="autresrevenus"
                  :itemprop="
                    $storeUm6p.Label.AutresRevenus.AutreRevenusNetAnnuels
                  "
                  v-bind:clearable="clearable"
                  v-bind:options="optionsDH"
                />
              </td>
              <td>
                <label
                  :class="
                    $storeCommun.AutreRevenuDto.AutresRevenus > 0
                      ? 'asterisk'
                      : ''
                  "
                >
                  {{ $storeUm6p.Label.AutresRevenus.PrecisezLaNature }}
                </label>
              </td>
              <td>
                <v-text-field
                  dense
                  outlined
                  v-model="$storeCommun.AutreRevenuDto.NatureRevenus"
                  :rules="
                    $storeCommun.AutreRevenuDto.AutresRevenus > 0
                      ? $storeReglesBourse.obligatoire
                      : []
                  "
                  ref="naturerevenus"
                  :itemprop="$storeUm6p.Label.AutresRevenus.NatureAutresRevenus"
                  :readonly="$storeCommun.ReadOnly"
                />
              </td>
            </tr>
          </tbody>
        </v-simple-table>
        <v-row>
          <v-col cols="12">
            <v-alert
              border="left"
              colored-border
              color="secondary"
              elevation="1"
            >
              {{
                $storeUm6p.Label.AutresRevenus.RevenuExceptionnels +
                $storeUm6p.Label.AutresRevenus.AutresRevenusTitle +
                $storeCommun.AnneeRevenus
              }}
            </v-alert>
          </v-col>
        </v-row>
        <v-simple-table>
          <tbody>
            <tr>
              <td>
                <label class="asterisk">
                  {{ $storeUm6p.Label.AutresRevenus.ProduitVenteImmo }}
                </label>
              </td>
              <td>
                <VuetifyMoney
                  hide-details
                  dense
                  v-model="$storeCommun.AutreRevenuDto.ProduitVenteBien"
                  v-bind:label="label"
                  v-bind:readonly="$storeCommun.ReadOnly"
                  v-bind:disabled="disabled"
                  v-bind:outlined="outlined"
                  :rules="$storeReglesBourse.obligatoire"
                  ref="produitventebien"
                  :itemprop="$storeUm6p.Label.AutresRevenus.ProduitVenteImmo"
                  v-bind:clearable="clearable"
                  v-bind:options="optionsDH"
                />
              </td>
              <td>
                <label class="asterisk">{{
                  $storeUm6p.Label.AutresRevenus.Heritages
                }}</label>
              </td>
              <td>
                <VuetifyMoney
                  hide-details
                  dense
                  v-model="$storeCommun.AutreRevenuDto.Heritage"
                  v-bind:label="label"
                  v-bind:readonly="$storeCommun.ReadOnly"
                  v-bind:disabled="disabled"
                  v-bind:outlined="outlined"
                  :rules="$storeReglesBourse.obligatoire"
                  ref="heritage"
                  :itemprop="$storeUm6p.Label.AutresRevenus.Heritages"
                  v-bind:clearable="clearable"
                  v-bind:options="optionsDH"
                />
              </td>
            </tr>
            <tr>
              <td>
                <label class="asterisk">
                  {{
                    $storeUm6p.Label.AutresRevenus.AutresRevenusExceptionnels
                  }}
                </label>
              </td>
              <td>
                <VuetifyMoney
                  hide-details
                  dense
                  v-model="
                    $storeCommun.AutreRevenuDto.AutresRevenusExceptionnels
                  "
                  v-bind:label="label"
                  v-bind:readonly="$storeCommun.ReadOnly"
                  v-bind:disabled="disabled"
                  :rules="$storeReglesBourse.obligatoire"
                  ref="autresrevenusexc"
                  :itemprop="
                    $storeUm6p.Label.AutresRevenus.AutresRevenusExceptionnels
                  "
                  v-bind:outlined="outlined"
                  v-bind:clearable="clearable"
                  v-bind:options="optionsDH"
                />
              </td>
              <td>
                <label
                  :class="
                    $storeCommun.AutreRevenuDto.AutresRevenusExceptionnels > 0
                      ? 'asterisk'
                      : ''
                  "
                >
                  {{ $storeUm6p.Label.AutresRevenus.PrecisezLaNature }}
                </label>
              </td>
              <td>
                <v-text-field
                  dense
                  outlined
                  v-model="
                    $storeCommun.AutreRevenuDto.NatureRevenusExceptionnels
                  "
                  :rules="
                    $storeCommun.AutreRevenuDto.AutresRevenusExceptionnels > 0
                      ? $storeReglesBourse.obligatoire
                      : []
                  "
                  ref="natureautrerevenuexc"
                  :itemprop="$storeUm6p.Label.AutresRevenus.PrecisezLaNatureExc"
                  :readonly="$storeCommun.ReadOnly"
                />
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import VuetifyMoney from "../VuetifyMoney";
import { mdiPlusThick, mdiDelete } from "@mdi/js";
export default {
  name: "AutresRevenusCandidat",
  components: {
    VuetifyMoney,
  },
  data() {
    return {
      $storeUm6p: this.$storeUm6p,
      $storeReglesBourse: this.$storeReglesBourse,
      $storeCatalogue: this.$storeCatalogue,
      $storeCommun: this.$storeCommun,
      dialogImmo: {
        informations: {
          model: false,
          texte: null,
        },
      },
      newBiens : {
        Supprimer: false,
        CandidatureBourse: this.$storeDemandeBourse.DonneesFormulaire.EncryptId,
        CandidatureBourseFirsi: this.$storeUm6p.Formulaire.Id,
        IdCrypte: null,
        SituationFamiliale: null,
        Adresse: null,
        Duree: null,
        NombreBiens: null,
        NumeroTitreFoncier: null,
        DateAcquisition: null,
        ValeurAcquisition: null,
        ValeurEstimative: null,
        SourceEstimation: null,
        MontantEcheance: null,
        MontantGlobal: null,
        Superficie: null,
        FinancementPropriete: this.$storeCatalogue.DataId.TypeRevenuPropriete,
        NatureBien: null,
        PersonneConcernee: this.$storeCatalogue.DataId.PersonneConcerneeCandidat,
        TypeFinancement: null,
      },

      // Icon importés depuis mdi/js pour les icones d'édition/suppression
      icons: {
        mdiPlusThick,
        mdiDelete,
      },
      // Param des rubriques revenus
      label: "",
      disabled: false,
      outlined: true,
      clearable: false,
      optionsDH: {
        locale: "fr-FR",
        prefix: "DH",
        suffix: "",
        length: 9,
        precision: 2,
      },
      optionsEUR: {
        locale: "fr-FR",
        prefix: "EUR",
        suffix: "",
        length: 9,
        precision: 2,
      },
    };
  },
  computed: {
    estProprietairedeBiensImmo() {
      return (
        this.$storeCommun.InfosCandidature
          .ProprietaireDeBiensImmobiliersSecondaire ==
        this.$storeCatalogue.DataId.Oui
      );
    },
  },
  mounted() {
    this.$refs.refAutresRevenusCandidat.resetValidation();
  },
  methods: {
    DisplayPopup(value) {
      if (value == this.$storeCatalogue.DataId.Oui) {
        this.dialogImmo.informations.model = true;
      } else if (value == this.$storeCatalogue.DataId.Non) {
        this.$storeCommun.ListeAutresRevenus.splice(0);
      }
    },
    ValiderForm() {
      this.$refs.refAutresRevenusCandidat.validate();
      let listeErreur = [];
      Object.keys(this.$refs).forEach((key) => {
        if (key != "refAutresRevenusCandidat") {
          if (
            (!this.$refs[key].valid && this.$refs[key].valid != undefined) ||
            (this.$refs[key].valid == undefined &&
              this.$refs[key].$children != undefined &&
              this.$refs[key].$children[0] != undefined &&
              !this.$refs[key].$children[0].valid) ||
            (this.$refs[key][0] != undefined && !this.$refs[key][0].valid)
          ) {
            let label = this.$refs[key].label;
            if (!label) {
              let inp = this.$refs[key];
              if (!inp.$attrs) {
                inp = inp[0];
              }
              label = inp.$attrs["itemprop"];
            }
            listeErreur.push(label);
          }
        }
      });
      return listeErreur;
    },
    addBienImmo(flag) {
      if(this.$storeCommun.InfosCandidature.ProprietaireDeBiensImmobiliersSecondaire == this.$storeCatalogue.DataId.Oui){
        if(flag){
          this.$storeCommun.ListeAutresRevenus.push(Object.assign({},this.newBiens));
        }
        else if(!flag && this.$storeCommun.ListeAutresRevenus.length === 0){
          this.$storeCommun.ListeAutresRevenus.push(Object.assign({},this.newBiens));
        }
      }
      else{
        this.$storeCommun.ListeAutresRevenus.splice(0);
      }
    },
    deleteBiens(index) {
      if (confirm("Etes-vous sûr de vouloir supprimer cette ligne?")) {
        let item = this.$storeCommun.ListeAutresRevenus[index];
        item.Supprimer = true;
        Object.assign(
          this.$storeCommun.ListeAutresRevenus[index],
          item
        );
      }
    },
  },
};
</script>
<style scoped src="@/assets/css/Um6pAutresRevenus.css"></style>
<style scoped src="@/assets/css/DemandeBourse.css"></style>
